import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import PosIncidentTable from '@pos/components/tables/pos-incident-table/pos-incident-table.vue';

@Component({
  name: 'bpc-pos-incidents',
  components: {
    'bpc-pos-incident-table': PosIncidentTable,
  },
})
export default class PosIncidents extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
